<template>
  <div>
    <About name="inicio" id="quemsomos" />
    <Bunner name="inicio" id="bunner" />
    <Products name="inicio" id="produtos" />
    <Blog name="inicio" id="noticias" />
    <ContactUs name="inicio" id="contactus" />
    <Footer/>
  </div>
</template>

<script>
import About from "@/components/About.vue";
import Bunner from "@/components/Bunner.vue";
import Products from "@/components/Products.vue";
import Blog from "@/components/Blog.vue";
import ContactUs from "@/components/ContactUs.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Products,
    Bunner,
    About,
    Blog,
    ContactUs,
    Footer,
  },
};
</script>
